import Popover from '@repo/editor/src/components/Popover/Popover';
import { PopoverAlign } from '@repo/editor/src/components/Popover/types';
import {
  notificationStoreSelector,
  useNotificationStore,
} from '@repo/editor/src/stores/notificationStore';
import { IconButton } from '@repo/ui/components/Buttons';
import BellClippedIcon from '@repo/ui/components/Icon/BellClippedIcon';
import BellClippedMobileIcon from '@repo/ui/components/Icon/BellClippedMobileIcon';
import BellIcon from '@repo/ui/components/Icon/BellIcon';
import { themeStyle } from '@repo/ui/theming';

import useWindowSize from 'global/utils/useWindowSize';

import Panel from './Panel';
import { Wrapper } from './styles';

const defaultTheme = {
  activeDefaultColor: themeStyle.varInkMain,
  activeColor: themeStyle.varInkMain,
};

const Notifications = ({ ...props }) => {
  const { isMobile } = useWindowSize();
  const showUnseenBadge = useNotificationStore(
    notificationStoreSelector.showUnseenBadge
  );

  const theme = {
    ...defaultTheme,
    ...props.theme,
  };

  return (
    <Popover
      align={PopoverAlign.End}
      content={<Panel />}
      dataTestId="notifications-menu"
      hideTip={isMobile}
      label="Notifications"
      margin={isMobile ? '8px 0 22px 0' : undefined}
      theme={{
        padding: isMobile ? '0 10px' : '0px',
        headPadding: isMobile ? '15px 12px 15px 0' : '12px',
        ...(isMobile ? { boxShadow: 'none' } : {}),
      }}
      width={isMobile ? '100%' : '300px'}
    >
      <Wrapper data-testid="notifications">
        <IconButton
          ariaLabel="Notifications"
          icon={
            showUnseenBadge
              ? props.forMobile
                ? BellClippedMobileIcon
                : BellClippedIcon
              : BellIcon
          }
          theme={theme}
          tooltipAlignment="center"
          tooltipPlacement="bottom"
          tooltipText="Notifications"
        />
      </Wrapper>
    </Popover>
  );
};

export default Notifications;
